import http from '../../../http-common.js';

export default {
  async getUsers(context) {
    try {
      const response = await http.get('/vendor');
      console.log(response.data);
      if (response.status == 200) {
        const responseData = response.data;
        context.commit('setUsers', responseData);
      } else {
        const error = new Error("Something'abc's went wrong!");
        throw error;
      }
    } catch (error) {
      const errorMessage = {
        status: error.response.data.success,
        message: new Error(error.response.data.message || 'Something failed!')
      };
      throw errorMessage;
    }
  },
  async createUser(context, data) {
    let userData;
    try {
      const response = await http.post('/vendor', data);
      if (response.status == 201) {
        userData = {
          username: data.username,
          password: data.password,
          role: data.role,
          name: data.name,
          email: data.email,
          phone: data.phone,
          status: 1,
          isLoggedIn: 0,
          can_manage_clients: data.can_manage_clients ? 1 : 0
        };
      } else {
        const error = new Error('Something went wrong!');
        throw error;
      }
    } catch (error) {
      const errorMessage = new Error(
        error.response.data.message || 'Something failed!'
      );
      throw errorMessage;
    }

    context.commit('addUser', userData);
  },
  async updateUser(context, data) {
    const username = data.username;
    const status = data.status;
    delete data.username;
    delete data.status;
    let userData;
    try {
      const response = await http.put(`/vendor/${username}`, data);
      if (response.status == 200) {
        // Local mirror of the DISPLAYED fields only. NEVER carry the
        // password into client state: it isn't rendered, and stashing the
        // typed plaintext here made the row "look changed" regardless of
        // what the server actually persisted (the optimistic-commit
        // illusion behind the "shows changed but vendor can't log in"
        // report). The list refetch below is the real source of truth.
        userData = {
          username: username,
          role: data.role,
          name: data.name,
          email: data.email,
          phone: data.phone,
          status: status,
          can_manage_clients: data.can_manage_clients ? 1 : 0
        };
      } else {
        const error = new Error('Something went wrong!');
        throw error;
      }
    } catch (error) {
      const errorMessage = new Error(
        error.response.data.message || 'Something failed!'
      );
      throw errorMessage;
    }

    context.commit('updateUser', userData);
  },
  async deleteUser(context, user) {
    const username = user.username;

    try {
      const response = await http.delete(`/vendor/${username}`);
      if (response.status == 200) {
        context.commit('deleteUser', username);
      } else {
        const error = new Error('Something went wrong!');
        throw error;
      }
    } catch (error) {
      const errorMessage = new Error(
        error.response.data.message || 'Something failed!'
      );
      throw errorMessage;
    }
  },
  async changeUserStatus(context, data) {
    const username = data.username;
    const status = data.status;
    try {
      const response = await http.post(`/users/${username}/status`, { status });
      if (response.status == 200) {
        context.commit('changeUserStatus', { username, status });
      } else {
        throw new Error('Something went wrong!');
      }
    } catch (error) {
      const errorMessage = new Error(
        (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'Something failed!'
      );
      throw errorMessage;
    }
  }
};
